import { Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";

import Footer from "@/app/ui/Footer";
import { MyBooking } from "@/app/ui/my-bookings/MyBooking";
import PageLoader from "@/app/ui/PageLoader";
import Loader from "@/app/ui/AnimatedLoader";
import { MyBookingHeader } from "@/app/ui/my-bookings/MyBookingHeader";
import { WhatsAppButton } from "@/app/ui/WhatsAppButton";
import type { SearchScope } from "@/app/lib/types/types";

export const Route = createFileRoute("/_authenticated/bookings_/$scope/$id")({
  params: {
    parse: (
      rawParams: Record<string, string>,
    ): { scope: SearchScope; id: string } => {
      if (!["flights", "hotels", "trips"].includes(rawParams.scope)) {
        throw new Error("Invalid scope");
      }
      return {
        scope: rawParams.scope as SearchScope,
        id: rawParams.id,
      };
    },
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { scope, id } = Route.useParams();

  return (
    <main className="main">
      <div className="min-h-full w-full overflow-auto">
        <Suspense
          fallback={
            <PageLoader>
              <Loader icon={scope === "hotels" ? "buildings" : "airplane"} />
            </PageLoader>
          }
        >
          <MyBookingHeader />

          <div className="px-4">
            <MyBooking scope={scope} reservationId={id} />
          </div>

          <WhatsAppButton />
        </Suspense>
      </div>

      <Footer />
    </main>
  );
}
